import {Component} from 'react'

import '../../../css/pages/overview/Gallery.css';

import location_1 from "../../../resources/images/essaouira/location_image1.jpg";
import location_2 from "../../../resources/images/essaouira/location_image2.jpg";
import location_3 from "../../../resources/images/essaouira/location_image3.jpg";
import location_4 from "../../../resources/images/essaouira/location_image4.jpg";
import location_6 from "../../../resources/images/essaouira/location_image5.jpg";
import location_7 from "../../../resources/images/essaouira/image3.jpg";
import location_8 from "../../../resources/images/essaouira/image4.jpg";
import location_9 from "../../../resources/images/essaouira/image5.jpg";
import location_10 from "../../../resources/images/essaouira/image7.jpg";
import location_11 from "../../../resources/images/essaouira/image8.jpg";
import location_12 from "../../../resources/images/essaouira/image9.jpg";
import location_13 from "../../../resources/images/essaouira/image12.jpg";
import location_14 from "../../../resources/images/essaouira/image13.jpg";
import location_15 from "../../../resources/images/essaouira/image14.jpg";
import location_16 from "../../../resources/images/essaouira/image15.jpg";
import location_17 from "../../../resources/images/essaouira/image16.jpg";
import location_18 from "../../../resources/images/essaouira/image17.jpg";
import location_19 from "../../../resources/images/essaouira/image18.jpg";
import location_20 from "../../../resources/images/essaouira/image19.jpg";
import location_21 from "../../../resources/images/essaouira/image20.jpg";
import location_22 from "../../../resources/images/essaouira/image21.jpg";
import location_23 from "../../../resources/images/essaouira/image22.jpg";
import location_24 from "../../../resources/images/essaouira/image23.jpg";
import location_25 from "../../../resources/images/essaouira/image24.jpg";
import location_26 from "../../../resources/images/essaouira/image25.jpg";
import location_27 from "../../../resources/images/essaouira/image26.jpg";
import location_28 from "../../../resources/images/essaouira/image27.jpg";
import location_29 from "../../../resources/images/essaouira/image28.jpg";
import location_30 from "../../../resources/images/essaouira/image30.jpg";
import location_31 from "../../../resources/images/essaouira/image31.jpg";

import history_1 from "../../../resources/images/history/history_image1.jpg";
import history_2 from "../../../resources/images/history/history_image2.jpg";
import history_3 from "../../../resources/images/history/history_image3.jpg";
import history_4 from "../../../resources/images/history/history_image4.jpg";
import history_5 from "../../../resources/images/history/history_image5.jpg";

import balcony_1 from "../../../resources/images/riad/balcony_1.jpg";
import balcony_2 from "../../../resources/images/riad/balcony_2.jpg";
import landing_1 from "../../../resources/images/riad/landing_1.jpg";
import landing_2 from "../../../resources/images/riad/landing_2.jpg";
import landing_3 from "../../../resources/images/riad/landing_3.jpg";
import room_1 from "../../../resources/images/riad/room_1.jpg";
import room_10 from "../../../resources/images/riad/room_10.jpg";
import room_11 from "../../../resources/images/riad/room_11.jpg";
import room_12 from "../../../resources/images/riad/room_12.jpg";
import room_13 from "../../../resources/images/riad/room_13.jpg";
import room_14 from "../../../resources/images/riad/room_14.jpg";
import room_15 from "../../../resources/images/riad/room_15.jpg";
import room_16 from "../../../resources/images/riad/room_16.jpg";
import room_17 from "../../../resources/images/riad/room_17.jpg";
import room_2 from "../../../resources/images/riad/room_2.jpg";
import room_3 from "../../../resources/images/riad/room_3.jpg";
import room_4 from "../../../resources/images/riad/room_4.jpg";
import room_5 from "../../../resources/images/riad/room_5.jpg";
import room_6 from "../../../resources/images/riad/room_6.jpg";
import room_7 from "../../../resources/images/riad/room_7.jpg";
import room_8 from "../../../resources/images/riad/room_8.jpg";
import room_9 from "../../../resources/images/riad/room_9.jpg";

import React from "react";
import ImageGridList from "../../components/ImageList";


const sections = [
    {
        title: "Riad Remmy",
        images: [
            {
                img: balcony_1,
                cols: 1
            },
            {
                img: balcony_2,
                cols: 1
            },
            {
                img: landing_1,
                cols: 1
            },
            {
                img: landing_2,
                cols: 1
            },
            {
                img: landing_3,
                cols: 1
            },
            {
                img: room_1,
                cols: 1
            },
            {
                img: room_2,
                cols: 1
            },
            {
                img: room_3,
                cols: 1
            },
            {
                img: room_4,
                cols: 1
            },
            {
                img: room_5,
                cols: 1
            },
            {
                img: room_6,
                cols: 1
            },
            {
                img: room_7,
                cols: 1
            },
            {
                img: room_8,
                cols: 1
            },
            {
                img: room_9,
                cols: 1
            },
            {
                img: room_10,
                cols: 1
            },
            {
                img: room_11,
                cols: 1
            },
            {
                img: room_12,
                cols: 1
            },
            {
                img: room_13,
                cols: 1
            },
            {
                img: room_14,
                cols: 1
            },
            {
                img: room_15,
                cols: 1
            },
            {
                img: room_16,
                cols: 1
            },
            {
                img: room_17,
                cols: 1
            }
        ]
    },
    {
        title: "Essaouria",
        images:
            [
                {
                    img: location_1,
                    title: "",
                    author: "",
                    cols: 1
                },
                {
                    img: location_2,
                    title: "",
                    author: "",
                    cols: 1
                },
                {
                    img: location_3,
                    title: "",
                    author: "",
                    cols: 1
                },
                {
                    img: location_4,
                    title: "",
                    author: "",
                    cols: 1
                },
                {
                    img: location_6,
                    cols: 1
                },
                {
                    img: location_7,
                    cols: 1
                },
                {
                    img: location_8,
                    cols: 1
                },
                {
                    img: location_9,
                    cols: 1
                },
                {
                    img: location_10,
                    cols: 1
                },
                {
                    img: location_11,
                    cols: 1
                },
                {
                    img: location_12,
                    cols: 1
                },
                {
                    img: location_13,
                    cols: 1
                },
                {
                    img: location_14,
                    cols: 1
                },
                {
                    img: location_15,
                    cols: 1
                },
                {
                    img: location_16,
                    cols: 1
                },
                {
                    img: location_17,
                    cols: 1
                },
                {
                    img: location_18,
                    cols: 1
                },
                {
                    img: location_19,
                    cols: 1
                },
                {
                    img: location_20,
                    cols: 1
                },
                {
                    img: location_21,
                    cols: 1
                },
                {
                    img: location_22,
                    cols: 1
                },
                {
                    img: location_23,
                    cols: 1
                },
                {
                    img: location_24,
                    cols: 1
                },
                {
                    img: location_25,
                    cols: 1
                },
                {
                    img: location_26,
                    cols: 1
                },
                {
                    img: location_27,
                    cols: 1
                },
                {
                    img: location_28,
                    cols: 1
                },
                {
                    img: location_29,
                    cols: 1
                },
                {
                    img: location_30,
                    cols: 1
                },
                {
                    img: location_31,
                    cols: 1
                }
            ]
    },
    {
        title: "History",
        images: [
            {
                img: history_1,
                title: "",
                author: "",
                cols: 1
            },
            {
                img: history_2,
                title: "",
                author: "",
                cols: 1
            },
            {
                img: history_3,
                title: "",
                author: "",
                cols: 1
            },
            {
                img: history_4,
                title: "",
                author: "",
                cols: 1
            },
            {
                img: history_5,
                title: "",
                author: "",
                cols: 1
            }
        ]
    },
];

class Gallery extends Component {

    render() {
        return (
            <div>
                {
                    sections.map(sec => (
                            <React.Fragment key={"gal-" + sec.title}>
                                <h3 className={"gal-title"}>{sec.title}</h3>
                                <ImageGridList images={sec.images}/>
                            </React.Fragment>
                    ))
                }
            </div>
        );
    }

}

export default Gallery;
